import React from 'react';

import { InfoItem } from '@molecules';

import { ICONS } from './constant';

const LinkItem = ({ url }) => {
  const site = React.useMemo(() => {
    const [, _site = 'Not found'] = /^https:\/\/(.*)\./.exec(url) || [];
    return _site;
  }, [url]);

  return (
    <InfoItem icon={ICONS[site]}>
      <a target="_blank" rel="noopener noreferrer" href={url}>
        {url}
      </a>
    </InfoItem>
  );
};

export default LinkItem;
